import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../common/components/form/form.module'


export default function OneUserBasicInfoComponent ({handleBasicFormChange,handleInnerFormChange,id,tagNames,tags, selectedOneUser}: any) {

  return (
    <>
      <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
                label="Phone"
                name="Phone"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'Login.Phone',
                    selectedOneUser?.Login
                  )
                }}
                type="number"
                value={selectedOneUser?.Login?.Phone}
            />
          <InputContainer
                label="Email"
                name="Email"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'Login.Email',
                    selectedOneUser?.Login
                  )
                }}
                type="text"
                value={selectedOneUser?.Login?.Email}
            />
            {id === '0' && (
            <InputContainer
                icon
                label="Password"
                name="Password"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'Login.Password',
                    selectedOneUser?.Login
                  )
                }}
                type="password"
                value={selectedOneUser?.Login?.Password}
            />)}
            {id === '0' && (
            <InputContainer
                icon
                label="Confirm Password"
                name="ConfirmPassword"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'Login.ConfirmPassword',
                    selectedOneUser?.Login
                  )
                }}
                type="password"
                value={selectedOneUser?.Login?.ConfirmPassword}
            />
  )}
            
          
      </div>
      }
      expandedPanel="userInfo"
      headerTitle="Basic Info"
      />
{ id > 0 && (
  <AccordionContainer
    child={
      <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
             <InputContainer
               label="Tag"
               labelField="displayText"
               list={tags?.length > 0 ? tags : tagNames}
               onValueChange={(event: any, newValue: any) => {
                 handleBasicFormChange(
                   event.target.value,
                   'TagEntityMappingsValueIds',
                 );
               }}
               optionName="Choose Contact Tag"
               type="select"
               value={selectedOneUser?.TagEntityMappingsValueIds}
               valueField="Id"
             />
           </div>
    }
    expandedPanel="ONEuser Tag"
    headerTitle="ONEuser Tag"
  />
)}

    </>
  )
}